

const PageWrapper = ({ children, title }) => (
    <div className="content">
        <div className="titleCell">
            <span>{title}</span>
        </div>
        <form id="indexForm" className="indexForm">
            {children}
        </form>
    </div>
);

export default PageWrapper;
